import locale from "localization/en";

export const orderSummaryColumn = [
  { key: "orderId", text: locale.orderId },
  { key: "stationCode", text: locale.stationCode },
  { key: "stationName", text: locale.stationName },
  { key: "stationType", text: locale.stationType },
  { key: "products", text: locale.products },
  { key: "amountInKL", text: locale.amountInKL, width: "150px" },
  { key: "amountInPhp", text: locale.amountInPhp },
  { key: "purchaseOrderNumber", text: locale.purchaseOrderNumber },
  { key: "salesOrderNumber", text: locale.salesOrderNumber },
  { key: "createdAt", text: locale.createdDateAndTime },
  { key: "status", text: `${locale.status}/${locale.dateAndTime}` },
  { key: "action", text: locale.action },
];
